import { render } from "./Offer.vue?vue&type=template&id=1ed6b32b&scoped=true"
import script from "./Offer.vue?vue&type=script&lang=js"
export * from "./Offer.vue?vue&type=script&lang=js"

import "./Offer.vue?vue&type=style&index=0&id=1ed6b32b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1ed6b32b"

export default script